//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  components: {},
  data() {
    return {
      IsShow: false,
      ActionColumns: [

      ],

      ActionItem:null,
      ActionIndex:0,
    };
  },
  props: ["dataConfig"],
  methods: {

    Show(){
      this.IsShow = true;
    },
    Hide(){
      this.IsShow = false;
    },

    setData($actionPicker){
      if(!$actionPicker) return;

      if($actionPicker.ColumnList && $actionPicker.ColumnList.length > 0){
          this.setColumnList($actionPicker);
          return;
      }

      if($actionPicker.ButtonList && $actionPicker.ButtonList.length > 0){
          this.setButtonList($actionPicker);
          return;
      }

    },

    setColumnList($actionPicker){
      var actionColumns = $actionPicker.ColumnList;
      if(!actionColumns) return;

      if(this.ActionColumns.length > 0){
        this.ActionColumns.splice(0,this.ActionColumns.length);
      }
      actionColumns.forEach(m => {
        // var actionColumnItem = {
        //   text : m.Text,
        //   dataItem : m.dataItem,
        // };
        var actionColumnItem = m;
        this.ActionColumns.push(actionColumnItem);
      });
    },


    setButtonList($actionPicker){
      var actionColumns = $actionPicker.ButtonList;
      if(!actionColumns) return;

      if(this.ActionColumns.length > 0){
        this.ActionColumns.splice(0,this.ActionColumns.length);
      }
      actionColumns.forEach(m => {
        var actionColumnItem = {
          text : m.Text,
          dataItem : m          
        }
        this.ActionColumns.push(actionColumnItem);
      });
    },

    async onActionConfirm(actionItem, index) {
      this.IsShow = false;

      this.ActionItem = actionItem;
      this.ActionIndex = index;

      console.log("onActionConfirm-actionItem",actionItem);
      console.log("onActionConfirm-index",index);

      var btnDataItem = null;
      if(actionItem instanceof Array){
        var row = index.length;
        var cindex = index[index.length - 1];

        var thisObj = this.ActionColumns[0];
        for(var i=1;i<index.length;i++){
          console.log("for--i",i);
          console.log("for--thisObj",thisObj);
          var j = index[i];
          thisObj = thisObj.children[j];
        }
        console.log("actionItem--thisObj",thisObj);
        btnDataItem = thisObj.dataItem;
      }else{
        btnDataItem = actionItem.dataItem;
      }

      if(!btnDataItem) return;

      var actionObj = this.$parent.$getActionObj();
      await this.$cmd.ExecuteCmd(btnDataItem,actionObj);

    },

    onActionCancel() {
      
      this.IsShow = false;

    },
    
  }
};
